<template>
	<a class="document-link" v-if="website" :href="website" target="_blank" ref="nofollow">Click Here</a>
</template>

<style scoped lang="scss">
    a.document-link {
        color: #557CEF;
    }
</style>

<script>
	import { mapState } from 'vuex';

	export default {
		name: 'ColumnWebsite',
		props: {
			rowData: {
				type: Object,
				required: true,
			},
			rowIndex: {
				type: Number,
			},
		},
		computed: {
			website() {
                return this.rowData.website;
			},
		},
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>
